import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './EmptySuggestions.module.scss';
import { SearchRecommendations } from 'src/modules/search/components/searchRecommendations/SearchRecommendations';
import { ProductCategoryEntity, ProductEntity } from 'src/modules/products';

interface EmptySuggestionsProps {
  topSearchedProducts: ProductEntity[];
  topSearchedProductCategories: ProductCategoryEntity[];
}

export const EmptySuggestions: FC<EmptySuggestionsProps> = ({
  topSearchedProducts,
  topSearchedProductCategories,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.resultsContainer}>
        <FormattedMessage id="search/empty_suggestions_notice" />
      </div>
      <SearchRecommendations
        className={styles.searchRecommendations}
        topSearchedProducts={topSearchedProducts}
        topSearchedProductCategories={topSearchedProductCategories}
      />
    </div>
  );
};
